import { createFileRoute } from '@tanstack/react-router'
import { InductionSettings } from '@/features/organizations/settings/induction'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/induction'
)({
  component: InductionSettings,
})

